export default __webpack_public_path__ + "2337611d8df567924a74da4d6f8c4f4f.svg";